import { Injectable } from '@angular/core';
import {
  ContactModel,
  IContactsStateError,
  IContactsStateSuccess,
} from '@boxx/contacts-core';
import { IStoreBase } from '@boxx/core';
import { Store } from '@ngrx/store';
import {
  CONTACT_FILTER_TYPE,
  IContactApiProps,
  IContactForm,
} from '../repositories/IContact.repository';
import * as fromActions from './contact.actions';
import * as fromContacts from './contact.reducer';
import * as fromSelector from './contact.selectors';
import { ContactInteractionsStore } from './interactions.store';

@Injectable()
export class ContactStore {
  constructor(
    public contacts: ContactsStore,
    public interactions: ContactInteractionsStore
  ) {}
}

@Injectable()
export class ContactsStore
  implements
    IStoreBase<ContactModel[], IContactsStateSuccess, IContactsStateError>
{
  constructor(public store: Store<fromContacts.ContactState>) {}

  get data$() {
    return this.store.select(fromSelector.getContactItems);
  }

  get error$() {
    return this.store.select(fromSelector.getError);
  }

  get success$() {
    return this.store.select(fromSelector.getSuccess);
  }

  get loading$() {
    return this.store.select(fromSelector.getIsLoading);
  }

  get filteredContacts$() {
    return this.store.select(fromSelector.getFilteredContactItems);
  }

  get fetched$() {
    return this.store.select(fromSelector.fetched);
  }

  contactById$(id: number) {
    this.store.dispatch(fromActions.selectContactAction({ contactId: id }));
    return this.store.select(fromSelector.getContactById);
  }

  fetch() {
    this.store.dispatch(fromActions.fetchContactBeginAction());
  }

  filter(criteria: CONTACT_FILTER_TYPE) {
    this.store.dispatch(
      fromActions.filterContactsBeginAction({ clientType: criteria })
    );
  }

  import(contactList: IContactApiProps[]) {
    this.store.dispatch(fromActions.importContactBeginAction({ contactList }));
  }

  create(contactForm: IContactForm) {
    this.store.dispatch(fromActions.createContactBeginAction({ contactForm }));
  }

  delete(contactId: number) {
    this.store.dispatch(fromActions.deleteContactBeginAction({ contactId }));
  }

  update(contactForm: IContactForm) {
    this.store.dispatch(fromActions.updateContactBeginAction({ contactForm }));
  }
}
